import { FontAwesome } from 'wiloke-react-core';

interface BusinessIconProps {
  size?: number;
}

export const BusinessIcon = ({ size = 12 }: BusinessIconProps) => {
  return <FontAwesome type="fas" size={size} name="medal" color="light" />;
};
